import { BarChart3 } from "lucide-react";
import { Outlet } from "react-router-dom";

export function ApprContentAttendance() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="mb-10">
        <div className="relative bg-white ">
          <div className="relative px-4 lg:px-6 py-4">
            <div className="flex items-center justify-between w-full mx-auto">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl shadow-lg">
                  <BarChart3 className="w-6 h-6 text-white" />
                </div>
                <div className="flex flex-col">
                  <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Présence
                  </h1>
                  <p className="text-xs text-gray-500 hidden sm:block">
                    Gestion des présences
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col flex-grow px-4 space-y-2">
        <Outlet />
      </div>
    </div>
  );
}
